<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">
              {{cvCardTitle}}
            </h4>
          </template>
          <template>
            <p v-show="!propOpenedInModal">
              {{cvCardSubHeader}}
            </p>
            <form action="#" v-if="vmeventLevelFormData && Object.keys(vmeventLevelFormData).length > 0">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label
                    for="validationevent_lev_name">
                    {{cvProfBulActLevelNameLabel}}</label>
                  <input
                    v-model="vmeventLevelFormData.event_lev_name"
                    type="text"
                    class="form-control"
                    required/>
                </div>
              </div>
            <div class="form-group row spinner_add">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary float-right" :disabled="cvLoadingStatus">
                  <b-spinner label="Spinning">
                  </b-spinner>
                </button>
                <button v-else type="button" class="btn btn-primary" @click="eventLevelEdit()">
                  {{cvSubmitBtn}}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>

<script>
import { eventLevels } from "../../../FackApi/api/eventLevel"
import ApiResponse from "../../../Utils/apiResponse.js"

export default {
  name: "eventLevelEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propeventLevelObj: {
      type: Object,
      default: function () {
        return {
          "event_lev_name": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Edit Event Level",
      cvCardSubHeader: "Edit Event Level ",
      cvSubmitBtn: "Edit",
      cvProfBulActLevelNameLabel: "Activity Level name",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Event Level",
      vmeventLevelFormData: {},
      cvLoadingStatus: false
    }
  },
  mounted () {
    this.eventLevelView()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmeventLevelFormData) {
          if (!this.vmeventLevelFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * eventLevelView
     */
    async eventLevelView () {
      try {
        if (this.propOpenedInModal) {
          this.vmeventLevelFormData = this.propeventLevelObj
        }
        else {
          let eventLevelId = this.$route.params.event_lev_id
          let eventLevelViewResp = await eventLevels.eventLevelView(this, eventLevelId)
          if (eventLevelViewResp && eventLevelViewResp.resp_status) {
            this.vmeventLevelFormData = eventLevelViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at eventLevelView() and Exception:", err.message)
      }
    },
    /**
     * eventLevelEdit
     */
    async eventLevelEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        let eventLevelAddResp = await eventLevels.eventLevelEdit(this, this.vmeventLevelFormData)
        await ApiResponse.responseMessageDisplay(this, eventLevelAddResp)
        if (eventLevelAddResp && !eventLevelAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseeventLevelEditModal", this.vmeventLevelFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at eventLevelEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
